import { render, staticRenderFns } from "./MobilePdfViewer.vue?vue&type=template&id=2c252851&scoped=true"
import script from "./MobilePdfViewer.vue?vue&type=script&lang=js"
export * from "./MobilePdfViewer.vue?vue&type=script&lang=js"
import style0 from "./MobilePdfViewer.vue?vue&type=style&index=0&id=2c252851&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c252851",
  null
  
)

export default component.exports